export const scrollToNewItem = (selector: string, idSelector?: boolean) => {
	if (idSelector) {
		const section = document.getElementById(selector);
		section && section.scrollIntoView({ behavior: 'smooth', block: 'center' });
	} else {
		const itemsArr = document.querySelectorAll(selector);
		itemsArr[itemsArr.length - 1].scrollIntoView({ behavior: 'smooth' });
	}
};
